import { axiosApiInstance } from './axios';

// -------------------------------------------------------------

const apiRoot = '';

const tobaccoSalesApi = {
  // GET
  getInventory: async (params) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/tobaccoSales/inventory`, { params });

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  // update
  updateStatus: async (id, status) => {
    try {
      const res = await axiosApiInstance.put(`${apiRoot}/tobaccoSales/changeStatus/${id}`, status);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  update: async (id, data) => {
    try {
      const res = await axiosApiInstance.put(`${apiRoot}/tobaccoSales/${id}`, data);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  cancel: async (id) => {
    try {
      const res = await axiosApiInstance.put(`${apiRoot}/tobaccoSales/cancel/${id}`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  // delete
  delete: async (saleContainerToDelete) => {
    try {
      const res = await axiosApiInstance.delete(
        `${apiRoot}/tobaccoSales/removeTobaccoContainer/${saleContainerToDelete.saleId}/${saleContainerToDelete.containerId}`
      );

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  getXlsx: async (id, type) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/tobaccoSales/report/${id}?type=${type}&format=xlsx`, {
        responseType: 'arraybuffer',
      });

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  getFilteredXlsx: async (params) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/tobaccoSales/report`, {
        params,
        responseType: 'arraybuffer',
      });

      return res;
    } catch (e: any) {
      return e.response;
    }
  },
};

export default tobaccoSalesApi;
